import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VContainer,
    [
      _c(VBreadcrumbs, {
        staticClass: "d-print-none",
        attrs: { items: _vm.breadCombs },
      }),
      _c(VDivider, { staticClass: "mx-4 d-print-none" }),
      _c(
        VRow,
        { staticClass: "d-print-none" },
        [
          _c(
            VCol,
            { attrs: { cols: "12", sm: "12", md: "12" } },
            [
              _c(
                VRow,
                [
                  _c(VDivider, {
                    staticClass: "mx-4",
                    attrs: { vertical: "" },
                  }),
                  _c(
                    VCol,
                    { attrs: { cols: "12", sm: "2", md: "2" } },
                    [
                      _c(VSelect, {
                        attrs: {
                          items: _vm.printSettings,
                          label: _vm.$vuetify.lang.t(
                            "$vuetify.printSetting.title"
                          ),
                        },
                        on: { change: _vm.selectChange },
                        model: {
                          value: _vm.selectId,
                          callback: function ($$v) {
                            _vm.selectId = $$v
                          },
                          expression: "selectId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(VDivider, {
                    staticClass: "mx-4",
                    attrs: { vertical: "" },
                  }),
                  _c(
                    VCol,
                    { attrs: { cols: "12", sm: "2", md: "1" } },
                    [
                      _c(VTextField, {
                        attrs: {
                          label: _vm.$vuetify.lang.t(
                            "$vuetify.printSetting.left"
                          ),
                          readonly: "",
                        },
                        model: {
                          value: _vm.printSetting.left,
                          callback: function ($$v) {
                            _vm.$set(_vm.printSetting, "left", $$v)
                          },
                          expression: "printSetting.left",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "12", sm: "2", md: "1" } },
                    [
                      _c(VTextField, {
                        attrs: {
                          label: _vm.$vuetify.lang.t(
                            "$vuetify.printSetting.right"
                          ),
                          readonly: "",
                        },
                        model: {
                          value: _vm.printSetting.right,
                          callback: function ($$v) {
                            _vm.$set(_vm.printSetting, "right", $$v)
                          },
                          expression: "printSetting.right",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "12", sm: "2", md: "1" } },
                    [
                      _c(VTextField, {
                        attrs: {
                          label: _vm.$vuetify.lang.t(
                            "$vuetify.printSetting.top"
                          ),
                          readonly: "",
                        },
                        model: {
                          value: _vm.printSetting.top,
                          callback: function ($$v) {
                            _vm.$set(_vm.printSetting, "top", $$v)
                          },
                          expression: "printSetting.top",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "12", sm: "2", md: "1" } },
                    [
                      _c(VTextField, {
                        attrs: {
                          label: _vm.$vuetify.lang.t(
                            "$vuetify.printSetting.bottom"
                          ),
                          readonly: "",
                        },
                        model: {
                          value: _vm.printSetting.bottom,
                          callback: function ($$v) {
                            _vm.$set(_vm.printSetting, "bottom", $$v)
                          },
                          expression: "printSetting.bottom",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "12", sm: "2", md: "1" } },
                    [
                      _c(VTextField, {
                        attrs: {
                          label: _vm.$vuetify.lang.t(
                            "$vuetify.printSetting.qrSize"
                          ),
                          readonly: "",
                        },
                        model: {
                          value: _vm.printSetting.qrSize,
                          callback: function ($$v) {
                            _vm.$set(_vm.printSetting, "qrSize", $$v)
                          },
                          expression: "printSetting.qrSize",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "12", sm: "2", md: "1" } },
                    [
                      _c(VTextField, {
                        attrs: {
                          label: _vm.$vuetify.lang.t(
                            "$vuetify.printSetting.fontSize"
                          ),
                          readonly: "",
                        },
                        model: {
                          value: _vm.printSetting.fontSize,
                          callback: function ($$v) {
                            _vm.$set(_vm.printSetting, "fontSize", $$v)
                          },
                          expression: "printSetting.fontSize",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "12", sm: "2", md: "1" } },
                    [
                      _c(VTextField, {
                        attrs: {
                          label: _vm.$vuetify.lang.t(
                            "$vuetify.printSetting.cols"
                          ),
                          readonly: "",
                        },
                        model: {
                          value: _vm.printSetting.cols,
                          callback: function ($$v) {
                            _vm.$set(_vm.printSetting, "cols", $$v)
                          },
                          expression: "printSetting.cols",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VRow,
        { staticClass: "d-print-none" },
        [
          _c(
            VCol,
            { attrs: { cols: "12", sm: "12", md: "8" } },
            [
              _c(
                VBtnToggle,
                [
                  _c(
                    VDialog,
                    {
                      attrs: { "max-width": "290" },
                      model: {
                        value: _vm.dialog,
                        callback: function ($$v) {
                          _vm.dialog = $$v
                        },
                        expression: "dialog",
                      },
                    },
                    [
                      _c(
                        VCard,
                        [
                          _c(VCardTitle, { staticClass: "headline" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$vuetify.lang.t("$vuetify.qrCode.genQr")
                              )
                            ),
                          ]),
                          _c(
                            VCardActions,
                            [
                              _c(
                                VRow,
                                [
                                  _c(
                                    VCol,
                                    {
                                      attrs: { cols: "12", sm: "12", md: "11" },
                                    },
                                    [
                                      _c(VTextField, {
                                        attrs: {
                                          label: _vm.$vuetify.lang.t(
                                            "$vuetify.qrCode.batchNum"
                                          ),
                                          "error-messages": _vm.errorMessage,
                                          required: "",
                                        },
                                        model: {
                                          value: _vm.addNum,
                                          callback: function ($$v) {
                                            _vm.addNum = $$v
                                          },
                                          expression: "addNum",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    {
                                      attrs: { cols: "12", sm: "12", md: "11" },
                                    },
                                    [
                                      _c(VTextField, {
                                        attrs: {
                                          label: _vm.$vuetify.lang.t(
                                            "$vuetify.qrCode.mark"
                                          ),
                                        },
                                        model: {
                                          value: _vm.mark,
                                          callback: function ($$v) {
                                            _vm.mark = $$v
                                          },
                                          expression: "mark",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    {
                                      attrs: { cols: "12", sm: "12", md: "11" },
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.encrypt,
                                            expression: "encrypt",
                                          },
                                        ],
                                        attrs: { type: "checkbox" },
                                        domProps: {
                                          checked: Array.isArray(_vm.encrypt)
                                            ? _vm._i(_vm.encrypt, null) > -1
                                            : _vm.encrypt,
                                        },
                                        on: {
                                          change: function ($event) {
                                            var $$a = _vm.encrypt,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = null,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  (_vm.encrypt = $$a.concat([
                                                    $$v,
                                                  ]))
                                              } else {
                                                $$i > -1 &&
                                                  (_vm.encrypt = $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1)))
                                              }
                                            } else {
                                              _vm.encrypt = $$c
                                            }
                                          },
                                        },
                                      }),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$vuetify.lang.t(
                                              "$vuetify.qrCode.encrypt"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            VBtn,
                            {
                              attrs: { color: "green darken-1", text: "" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  _vm.dialog = false
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$vuetify.lang.t("$vuetify.base.cancel")
                                )
                              ),
                            ]
                          ),
                          _c(
                            VBtn,
                            {
                              attrs: { color: "green darken-1", text: "" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.batchGenNo.apply(null, arguments)
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$vuetify.lang.t("$vuetify.base.confirm")
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(VDivider, { staticClass: "d-print-none" }),
      _c(
        VRow,
        {
          staticClass: "mx-4 d-print-none",
          attrs: { justify: "space-between" },
        },
        [
          _c(
            VCol,
            { attrs: { cols: "12", sm: "12", md: "2" } },
            [
              _c(VTextField, {
                attrs: { label: _vm.$vuetify.lang.t("$vuetify.qrCode.mark") },
                model: {
                  value: _vm.searchMark,
                  callback: function ($$v) {
                    _vm.searchMark = $$v
                  },
                  expression: "searchMark",
                },
              }),
            ],
            1
          ),
          _c(
            VCol,
            { attrs: { cols: "12", sm: "12", md: "2" } },
            [
              _c(VTextField, {
                attrs: {
                  label: _vm.$vuetify.lang.t("$vuetify.qrCode.categoryPath"),
                },
                model: {
                  value: _vm.categoryPath,
                  callback: function ($$v) {
                    _vm.categoryPath = $$v
                  },
                  expression: "categoryPath",
                },
              }),
            ],
            1
          ),
          _c(
            VCol,
            { attrs: { cols: "12", sm: "12", md: "3" } },
            [
              _c(VSelect, {
                attrs: {
                  items: _vm.$vuetify.lang.t("$vuetify.qrCode.uses"),
                  label: _vm.$vuetify.lang.t("$vuetify.qrCode.isUsed"),
                },
                model: {
                  value: _vm.searchUsed,
                  callback: function ($$v) {
                    _vm.searchUsed = $$v
                  },
                  expression: "searchUsed",
                },
              }),
            ],
            1
          ),
          _c(
            VCol,
            { attrs: { cols: "12", sm: "12", md: "3" } },
            [
              _c(VSelect, {
                attrs: {
                  items: _vm.$vuetify.lang.t("$vuetify.qrCode.prints"),
                  label: _vm.$vuetify.lang.t("$vuetify.qrCode.isPrinted"),
                },
                model: {
                  value: _vm.printed,
                  callback: function ($$v) {
                    _vm.printed = $$v
                  },
                  expression: "printed",
                },
              }),
            ],
            1
          ),
          _c(
            VCol,
            { staticClass: "mt-6", attrs: { cols: "12", sm: "12", md: "12" } },
            [
              _c(
                VBtn,
                {
                  staticClass: "primary white--text mr-2",
                  attrs: { small: "" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.search.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("strong", [
                    _vm._v(_vm._s(_vm.$vuetify.lang.t("$vuetify.base.search"))),
                  ]),
                ]
              ),
              _c(
                VBtn,
                {
                  staticClass: "indigo white--text mr-4",
                  attrs: { small: "" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      _vm.dialog = true
                    },
                  },
                },
                [
                  _vm._v(
                    _vm._s(_vm.$vuetify.lang.t("$vuetify.qrCode.batchGenQr"))
                  ),
                ]
              ),
              _c(
                VBtn,
                {
                  directives: [
                    {
                      name: "print",
                      rawName: "v-print",
                      value: _vm.printObj,
                      expression: "printObj",
                    },
                  ],
                  staticClass: "primary white--text ml-6",
                  attrs: { small: "" },
                },
                [
                  _c("strong", [
                    _vm._v(
                      _vm._s(_vm.$vuetify.lang.t("$vuetify.printSetting.print"))
                    ),
                  ]),
                ]
              ),
              _c(
                VBtn,
                {
                  staticClass: "primary white--text ml-2",
                  attrs: { small: "" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.markedPrinted.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("strong", [
                    _vm._v(
                      _vm._s(_vm.$vuetify.lang.t("$vuetify.qrCode.markPrinted"))
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VRow,
        _vm._l(_vm.qrCodes, function (qrCode, index) {
          return _c(
            VCol,
            {
              key: index,
              style: {
                paddingTop: _vm.printSetting.top + "px",
                paddingRight: _vm.printSetting.right + "px",
                paddingBottom: _vm.printSetting.bottom + "px",
                paddingLeft: _vm.printSetting.left + "px",
                fontSize: _vm.printSetting.fontSize + "pt",
              },
              attrs: { cols: "12", sm: "6", md: 12 / _vm.printSetting.cols },
            },
            [
              _c(
                "div",
                { staticStyle: { display: "flex", "flex-direction": "row" } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: { position: "relative", clear: "both" },
                      style: { width: _vm.printSetting.qrSize + "px" },
                    },
                    [
                      _vm.companyName.startsWith("Bergsoe")
                        ? _c("img", {
                            staticStyle: {
                              position: "absolute",
                              clear: "both",
                            },
                            style: {
                              width: _vm.printSetting.qrSize / 5 + "px",
                              marginTop:
                                (_vm.printSetting.qrSize / 10) * 4 + "px",
                              marginLeft:
                                (_vm.printSetting.qrSize / 10) * 4 + "px",
                            },
                            attrs: { src: require("../../assets/logo.png") },
                          })
                        : _c("img", {
                            staticStyle: {
                              position: "absolute",
                              clear: "both",
                            },
                            style: {
                              width: _vm.printSetting.qrSize / 5 + "px",
                              marginTop:
                                (_vm.printSetting.qrSize / 10) * 4 + "px",
                              marginLeft:
                                (_vm.printSetting.qrSize / 10) * 4 + "px",
                            },
                            attrs: {
                              src: require("../../assets/panya-logo.png"),
                            },
                          }),
                      _c("qriously", {
                        attrs: {
                          value: qrCode.codeInfo,
                          size: _vm.printSetting.qrSize,
                        },
                      }),
                    ],
                    1
                  ),
                  _c("div", { staticStyle: { "margin-left": "10px" } }, [
                    _c("div", { staticClass: "red--text d-print-none" }, [
                      _vm._v(
                        _vm._s(
                          qrCode.used
                            ? _vm.$vuetify.lang.t("$vuetify.qrCode.used")
                            : _vm.$vuetify.lang.t("$vuetify.qrCode.unUsed")
                        )
                      ),
                    ]),
                    qrCode.categoryPath != null
                      ? _c("div", [_vm._v(_vm._s(qrCode.categoryPath))])
                      : _vm._e(),
                    qrCode.mark != null
                      ? _c("div", [_vm._v(_vm._s(qrCode.mark))])
                      : _vm._e(),
                  ]),
                ]
              ),
            ]
          )
        }),
        1
      ),
      _c(
        VRow,
        { staticClass: "d-print-none", attrs: { justify: "center" } },
        [
          _c(
            VCol,
            { attrs: { cols: "8" } },
            [
              _c(
                VContainer,
                [
                  _c(VPagination, {
                    staticClass: "my-4",
                    attrs: { length: _vm.totalPage },
                    on: { input: _vm.changeNo },
                    model: {
                      value: _vm.pageNo,
                      callback: function ($$v) {
                        _vm.pageNo = $$v
                      },
                      expression: "pageNo",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VCol,
            { staticClass: "my-4", attrs: { cols: "1" } },
            [
              _c(VSelect, {
                attrs: { items: _vm.pageSizes },
                on: { change: _vm.pageSizeChange },
                model: {
                  value: _vm.pageSize,
                  callback: function ($$v) {
                    _vm.pageSize = $$v
                  },
                  expression: "pageSize",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }